import { ChangeDetectorRef, Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  SoleBusiness,
  SoleDetails,
  SoleDetailsService,
  SoleInvoiceTemplate,
  SoleInvoiceTemplateService,
  SoleInvoiceTemplateTaxTypeEnum
} from 'taxtank-core';
import { NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs';
import { InvoiceTemplateFormDialogComponent } from '@client/sole/invoices/components/invoice-template/invoice-template-form-dialog/invoice-template-form-dialog.component';
import { plainToClass } from 'class-transformer';
import { AbstractSelectComponent } from '../abstract-select/abstract-select.component';

@Component({
  selector: 'app-sole-invoice-template-select',
  templateUrl: './sole-invoice-template-select.component.html',
  styleUrls: ['./sole-invoice-template-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleInvoiceTemplateSelectComponent extends AbstractSelectComponent<SoleInvoiceTemplate> implements OnInit {
  protected dialog = inject(MatDialog);
  private soleInvoiceTemplateService = inject(SoleInvoiceTemplateService);
  private soleDetailsService = inject(SoleDetailsService);

  @Input() business: SoleBusiness;
  @Input() emptyMessage = 'You haven\'t added any sole businesses yet.';
  @Input() emptyOptionLabel = 'All sole businesses';
  @Input() placeholder = 'Select template';
  @Input() label = 'Template';
  soleDetails: SoleDetails;
  dialogComponent = InvoiceTemplateFormDialogComponent;

  ngOnInit() {
    this.soleDetailsService.getFirst()
      .pipe(takeUntil(this.destroy$))
      .subscribe((soleDetails) => {
        this.soleDetails = soleDetails;
      });

    super.ngOnInit();
  }

  openAddItemDialog(): void {
    super.openAddItemDialog(plainToClass(SoleInvoiceTemplate, {
      business: this.business,
      taxType: this.business.getIsGST(this.soleDetails) ? SoleInvoiceTemplateTaxTypeEnum.TAX_EXCLUSIVE : SoleInvoiceTemplateTaxTypeEnum.NO_TAX
    }));
  }

  getOptions$(): Observable<SoleInvoiceTemplate[]> {
    return this.soleInvoiceTemplateService.get().pipe(
      map((templates: SoleInvoiceTemplate[]) => templates.filter((template: SoleInvoiceTemplate) => template.business.id === this.business.id))
    );
  }
}
